import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles.ts'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext.tsx'
import { Loadable } from '../base/components/Lodable.tsx'

const ProduccionRegistro = lazy(() => import('./view/ProduccionRegistro.tsx'))
const ProduccionActualizar = lazy(() => import('./view/ProduccionActualizar.tsx'))
const ProduccionConsultar = lazy(() => import('./view/ProduccionConsultar.tsx'))
const ProduccionRectificar = lazy(() => import('./view/ProduccionRectificar.tsx'))
const ProduccionFinalizar = lazy(() => import('./view/ProduccionFinalizar.tsx'))
// const NotasDeProduccionIniciado = lazy(() => import('./view/NoDeProIniciado'))
const NdpIniciarGestion = lazy(() => import('./view/ProduccionIniciarGestion.tsx'))
const NdpCompletarGestion = lazy(() => import('./view/ProduccionCompletarGestion.tsx'))
const NdpFinalizarGestion = lazy(() => import('./view/ProduccionFinalizarGestion.tsx'))
const ProduccionConsultarGestion = lazy(() => import('./view/ProduccionConsultarGestion.tsx'))

const ProduccionRegistroRapidoGestion = Loadable(
  lazy(() => import('./view/ProduccionRegistroRapidoGestion.tsx')),
)
const ProduccionRegistroRapido = Loadable(lazy(() => import('./view/ProduccionRegistroRapido.tsx')))

export const produccionRoutesMap = {
  registroRapidoGestion: {
    path: '/produccion/registro-rapido-gestion',
    name: 'Producción rápida',
    action: 'PRODUCCION_RAPIDA',
  },
  registroRapido: {
    path: '/produccion/registro-rapido',
    name: 'Nueva producción rápida',
    action: 'PRODUCCION_RAPIDA',
  },
  iniciarGestion: {
    path: '/produccion/registro-gestion',
    name: 'Iniciar',
    action: 'INICIAR_PRODUCCION',
  },
  registro: {
    path: '/produccion/registro',
    name: 'Nueva Producción',
    action: 'ADMINISTRAR',
  },
  actualizar: {
    path: '/produccion/actualizar/:id',
    name: 'Actualizar Producción',
    action: 'ADMINISTRAR',
  },
  completadoGestion: {
    path: '/produccion/completar-gestion',
    name: 'Completar',
    action: 'COMPLETAR_PRODUCCION',
  },
  rectificar: {
    path: '/produccion/rectificar/:id',
    name: 'Rectificar producción',
    action: 'RECTIFICAR',
  },
  finalizar: {
    path: '/produccion/finalizar/:id',
    name: 'Finalizar producción',
    action: 'ADMINISTRAR',
  },
  finalizarGestion: {
    path: '/produccion/finalizar-gestion',
    name: 'Finalizar',
    action: 'FINALIZAR_PRODUCCION',
  },
  consultar: {
    path: '/produccion/consultar/:id',
    name: 'Consultar producción',
    action: 'CONSULTAR_PRODUCCION',
  },
  consultarGestion: {
    path: '/produccion/consultar-gestion',
    name: 'Consultar',
    action: 'CONSULTAR_PRODUCCION',
  },
}
const produccionRoutes = [
  {
    path: produccionRoutesMap.registroRapidoGestion.path,
    element: (
      <OperacionesProvider>
        <ProduccionRegistroRapidoGestion />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: produccionRoutesMap.registroRapido.path,
    element: (
      <OperacionesProvider>
        <ProduccionRegistroRapido />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: produccionRoutesMap.consultarGestion.path,
    element: (
      <OperacionesProvider>
        <ProduccionConsultarGestion />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: produccionRoutesMap.consultar.path,
    element: (
      <OperacionesProvider>
        <ProduccionConsultar />
      </OperacionesProvider>
    ),
  },
  {
    path: produccionRoutesMap.registro.path,
    element: (
      <OperacionesProvider>
        <ProduccionRegistro />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: produccionRoutesMap.iniciarGestion.path,
    element: (
      <OperacionesProvider>
        <NdpIniciarGestion />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: produccionRoutesMap.actualizar.path,
    element: (
      <OperacionesProvider>
        <ProduccionActualizar />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: produccionRoutesMap.rectificar.path,
    element: (
      <OperacionesProvider>
        <ProduccionRectificar />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: produccionRoutesMap.finalizar.path,
    element: (
      <OperacionesProvider>
        <ProduccionFinalizar />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: produccionRoutesMap.finalizarGestion.path,
    element: (
      <OperacionesProvider>
        <NdpFinalizarGestion />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: produccionRoutesMap.completadoGestion.path,
    element: (
      <OperacionesProvider>
        <NdpCompletarGestion />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
]
export default produccionRoutes
